// import "./styles.css";
import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Posts from "./pages/Posts";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Portfolio from "./pages/Portfolio";
import Resume from "./pages/Resume";
import AvSyncPage from "./pages/AvSyncpage";
// AvSync Docs ----
import Docs from "./pages/avsync/Docs";
import ScannerDocs from "./pages/avsync/ScannerDocs";
import Handoff from "./pages/avsync/Handoff";

function App() {
  return (
    <Router>
      <div className="app-container">
        <NavBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/posts" element={<Posts />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/avsync" element={<AvSyncPage />} />
          {/* AV Sync - Docs */}

          <Route path="/avsync/docs" element={<Docs />} />

          <Route path="/avsync/scanner" element={<ScannerDocs />} />

          <Route path="/avsync/handoff" element={<Handoff />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
